/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Faint_Ram_PurrInputs */

const en_still_faint_ram_purr = /** @type {(inputs: Still_Faint_Ram_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has custom config`)
};

const de_still_faint_ram_purr = /** @type {(inputs: Still_Faint_Ram_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat benutzerdefinierte Konfiguration`)
};

/**
* | output |
* | --- |
* | "Has custom config" |
*
* @param {Still_Faint_Ram_PurrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const still_faint_ram_purr = /** @type {((inputs?: Still_Faint_Ram_PurrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Faint_Ram_PurrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_still_faint_ram_purr(inputs)
	return de_still_faint_ram_purr(inputs)
});